import React from 'react';
import { motion } from 'framer-motion';

export default function Contact() {
  return (
    <div className="bg-white">
      {/* Business Card Section */}
      <div className="relative border-t border-gray-100 bg-white">
        <div className="relative mx-auto max-w-7xl px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 pt-16 pb-12 lg:pt-24 lg:pb-16 items-center">
            {/* Left Column: Contact Details (Identity, Address, Channels) */}
            <div className="space-y-8 font-sans pointer-events-auto">
              {/* Group 1: Identity */}
              <div className="flex flex-col gap-1">
                <h1 className="text-3xl md:text-4xl font-bold tracking-tight text-slate-800">
                  Henrik Nielsen
                </h1>
                <span className="text-lg font-medium text-orange-600">
                  Ejer
                </span>
              </div>

              {/* Group 2: Company & Address */}
              <div className="flex flex-col text-base md:text-lg leading-relaxed text-slate-600 space-y-1">
                <span className="font-semibold text-slate-800 text-lg">HN Promotion</span>
                <span>Algade 12</span>
                <span>4000 Roskilde</span>
              </div>

              {/* Group 3: Contact Channels */}
              <div className="flex flex-col text-base md:text-lg leading-relaxed text-slate-600 space-y-3 pt-6 border-t border-gray-100">
                <div className="grid grid-cols-[2rem_1fr] gap-x-2 items-center">
                  <span className="font-bold text-slate-400">T:</span>
                  <a href="tel:+4551821153" className="hover:text-orange-600 transition-colors font-semibold text-slate-800">+45 5182 1153</a>
                </div>
                <div className="grid grid-cols-[2rem_1fr] gap-x-2 items-center">
                  <span className="font-bold text-slate-400">W:</span>
                  <a href="https://HNpromotion.dk" target="_blank" rel="noopener noreferrer" className="hover:text-orange-600 transition-colors font-semibold text-slate-800">HNpromotion.dk</a>
                </div>
                <div className="grid grid-cols-[2rem_1fr] gap-x-2 items-center">
                  <span className="font-bold text-slate-400">M:</span>
                  <a href="mailto:henrik@hnpromotion.dk" className="hover:text-orange-600 transition-colors font-semibold text-slate-800 break-all">henrik@hnpromotion.dk</a>
                </div>
              </div>
            </div>

            {/* Right Column: Logo */}
            <div className="flex flex-col items-center lg:items-end justify-center pointer-events-auto">
              <img 
                src="https://assets.auxodev.dk/assets/aeb461c8-3829-4985-b2c9-ddf73ce34675/32669e46-fb20-4cf5-8352-706003725d36.png" 
                alt="HN Promotion Logo" 
                className="max-h-36 md:max-h-48 w-auto object-contain"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Announcement Banner */}
      <div className="w-full bg-orange-500 py-3 px-4 text-center">
        <p className="text-white text-sm sm:text-base font-normal tracking-wide">
          Besøg vores showroom i Skovlunde (kun efter aftale)
        </p>
      </div>

      {/* Holiday Announcement */}
      <div className="w-full bg-amber-50 border-y border-amber-200 py-3 px-4 text-center">
        <p className="text-amber-900 text-sm sm:text-base font-medium">
          <span className="font-semibold">Lukket i efterårsferien:</span> Vi holder lukket hele ugen i efterårsferien (uge 42).
        </p>
      </div>

      {/* Map Section */}
      <div className="relative h-96 bg-gray-100 border-t border-gray-200">
        <iframe
          title="HN Promotion Beliggenhed"
          src="https://maps.google.com/maps?q=Algade%2012,%204000%20Roskilde&t=&z=15&ie=UTF8&iwloc=&output=embed"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          className="grayscale contrast-125 opacity-80"
        ></iframe>
        <div className="absolute bottom-6 left-6 bg-white p-6 shadow-lg border border-gray-100 max-w-xs hidden sm:block">
          <h4 className="font-bold text-gray-900 text-sm uppercase tracking-wider mb-2">HN Promotion</h4>
          <p className="text-xs text-gray-600 leading-relaxed">
            Algade 12<br />
            4000 Roskilde<br />
            Danmark
          </p>
          <a 
            href="https://maps.google.com/?q=Algade+12,+4000+Roskilde" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="mt-3 inline-block text-xs font-bold text-orange-500 hover:text-orange-600 uppercase tracking-wider"
          >
            Få rutevejledning &rarr;
          </a>
        </div>
      </div>
    </div>
  );
}
